/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import ErrorBoundary from 'base/components/ErrorBoundary';
import LabradorBodytext from 'base/components/labrador/Bodytext';

export const DynamicLabradorBodytext: typeof LabradorBodytext = (props) => {
    return <ErrorBoundary><LabradorBodytext {...props} /></ErrorBoundary>;
}
export type DynamicLabradorBodytextProps = PropsFromComponent<typeof LabradorBodytext>;
